function getCookie(name) {
    let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

(function () {
    const params = window.location.search;
    const utmSource = new URLSearchParams(params).get('utm_source');
    const linkUtm = document.querySelectorAll('.link-utm');

    let refParam = '';

    if (utmSource) {
        refParam = params;
        document.cookie = 'target_url=' + params + '; path=/; domain=' + location.hostname + '; max-age=2592000; Secure; SameSite=Strict';
    } else {
        refParam = getCookie('target_url') ? getCookie('target_url') : '?utm_source=cashxloan&utm_medium=site';
    }

    if (linkUtm) {
        linkUtm.forEach(el => {
            el.href = el.href + refParam;
        });
    }
}());

(function () {
    const browserOpenLinks = document.querySelectorAll('[data-webview]');

    if (browserOpenLinks) {
        browserOpenLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();

                const userAgent = navigator.userAgent || navigator.vendor;
                const targetUrl = getCookie('target_url') || '?utm_source=cashxloan&utm_medium=site';
                const paramsUrl = targetUrl.split("?");
                const fullUrl = link.href + '?' + paramsUrl[1]
                const shortUrl = link.href.slice(8) + '?' + paramsUrl[1]

                if (/iPad|iPhone/.test(userAgent)) {
                    window.location.href = `googlechrome://${shortUrl}`;

                    setTimeout(() => window.location.href = fullUrl, 3000)
                    return;
                }

                window.location.href = `intent:${fullUrl}#Intent;end`;

                setTimeout(() => window.location.href = fullUrl, 3000)
                return;
            });
        });
    }
}());
